import ReportEmail from 'modules/reports/models/ReportEmail'
import ListEndpoint from 'modules/reports/orm/endpoints/ListEndpoint'

type ListReportEmailsRequest = {
  reportId: number
}

class ListReportEmailsEndpoint extends ListEndpoint<ListReportEmailsRequest, ReportEmail> {
  model = ReportEmail

  urlParams = ['reportId']

  buildPath(request: ListReportEmailsRequest) {
    return `reports/${request.reportId}/report_emails`
  }
}

export default new ListReportEmailsEndpoint().fetch
